import { ACTION_TYPES } from '../constants';

export default () => ({
  type: ACTION_TYPES.AUTH_VOD_REQUEST
});
